import styled, { css } from 'styled-components';

import { ProductSearch } from '@hero/components/molecules/ProductSearch/style';
import { constants } from '@hero/configs';
import { DEVICE } from '@hero/constants';

const HomeTemplate = styled.div`
  .swiper-button-next:after,
  .swiper-button-prev:after {
    font-size: 18px;
  }
`;

const Categories = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-top: 40px;
  padding-left: 56px;
  padding-right: 56px;

  ${DEVICE.mobile.max} {
    background-color: transparent;
    padding: 0;
  }

  ${ProductSearch} {
    left: 0 !important;
    max-width: 100%;
    padding: 0;
    width: 100%;

    input {
      height: 40px !important;
      padding-left: 16px !important;
      transition: all 0.3s ease;
    }
  }
`;

const HeaderWrapper = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
`;

const ProductCardWrapper = styled.div``;

const ProductSearchContainer = styled.div`
  height: 40px;
`;

const ProductCardsContainer = styled.div`
  display: grid;
  grid-column-gap: 24px;
  grid-row-gap: 24px;
  margin-bottom: 16px;

  ${() => {
    return css`
      grid-template-columns: repeat(auto-fill, minmax(${constants?.products?.card?.width}, 1fr));
    `;
  }}
`;

export {
  Categories,
  Content,
  HeaderWrapper,
  HomeTemplate,
  ProductCardWrapper,
  ProductCardsContainer,
  ProductSearchContainer
};
